import { Form } from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  displayNameSelector,
  photoURLSelector,
} from "store/user/auth/user_auth.selector";
//
//component
//redux
//selector
//actions
const TriggerAccountInfo = () => {
  // -------------------------- VAR ----------------------------
  const form = Form?.useFormInstance();
  const [searchParams] = useSearchParams();
  const viewOpenAccount = searchParams.get("viewOpenAccount") || "false";
  const openAccount = viewOpenAccount === "true";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const displayName = useSelector(displayNameSelector);
  const photoURL = useSelector(photoURLSelector);

  console.log({ displayName });

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (openAccount) {
      const base64 = photoURL || null;
      form?.setFieldsValue({ displayName, base64 });
    }
  }, [openAccount, dispatch, photoURL, displayName, form]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerAccountInfo;
